export default {"src":"/_next/static/media/google.e8557f5b.svg","height":24,"width":25};